// logger.js
const LOG_LEVELS = {
  ALL: 0,
  DEBUG: 1,
  INFO: 2,
  WARN: 3,
  ERROR: 4,
  SILENT: 5,
  RND: 6,
};

let currentLogLevel = LOG_LEVELS.INFO;

const logger = {
  setLogLevel: (level) => {
    currentLogLevel = LOG_LEVELS[level] || LOG_LEVELS.DEBUG;
  },
  debug: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.DEBUG) {
      console.log("currentLogLevel", currentLogLevel, console.trace());
      // console.debug("[DEBUG]", ...args, console.trace());
    }
  },
  info: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.INFO) {
      console.info("[INFO]", ...args);
    }
  },
  warn: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.WARN) {
      console.warn("[WARN]", ...args);
    }
  },
  error: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.ERROR) {
      console.error("[ERROR]", ...args, console.trace());
    }
  },
  rnd: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.RND) {
      console.info("[RND]", ...args);
    }
  },
};

export default logger;
